require('./lbFiveStarRating.scss');

const $inject = [];

const lbFiveStarRating = function () {
  return {
    template: require('./lbFiveStarRatingTemplate.html'),
    controller: 'lbFiveStarRatingController',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      rating: '=',
    },
  };
};

lbFiveStarRating.$inject = $inject;

export default lbFiveStarRating;



// WEBPACK FOOTER //
// ./src/components/lbFiveStarRating/lbFiveStarRatingDirective.js